"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _colors = require("HubStyleTokens/colors");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-color: ", ";\n  border-top: 0;\n  border-right: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AbsoluteFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "CurrentPlanTag__AbsoluteFlex",
  componentId: "sc-10bab4d-0"
})(_templateObject());
var Tag = (0, _styledComponents.default)(_UITag.default).withConfig({
  displayName: "CurrentPlanTag__Tag",
  componentId: "sc-10bab4d-1"
})(_templateObject2(), _colors.BATTLESHIP);

var CurrentPlanTag = function CurrentPlanTag() {
  return _react.default.createElement(AbsoluteFlex, {
    justify: "end"
  }, _react.default.createElement(Tag, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.highlightedMerchCards.currentPlan"
  })));
};

var _default = CurrentPlanTag;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/CurrentPlanTag.js
// module id = 487
// module chunks = 5 6